import React from 'react';
const highlights = ['Four sizes TC300, TC400, TC600, TC800', 'Live turning lengths 400 to 1500 mm', 'Tailstock or sub-spindle versions', 'GE-Fanuc 31i or Siemens 840D SolutionLine', 'Conversational programming', 'Big turning diameter and large working area', 'Real Y-Axis (optional)', 'Standardized integrated loading systems available for chucking operations'];
const mechanicalEngineering = ['Hardened and ground guide ways of big size', 'Rigid cast machine body made of Mehanite®', 'Large bar feed capacity', 'High main spindle power', 'Dynamic built-in spindles (TC 300 – TC 800-85)', '1:4 automatic gear for high torque (TC 800-110)', 'Radial tooling on turret for up to 32 tools to work with either left or right spindles', 'Toolholders according to VDI or BMT', 'Tool-setter for presetting of cutting tools in working area'];
export function SpecsSection() {
  return <div className="grid md:grid-cols-2 gap-12 mb-20" data-id="element-3957">
      <div data-id="element-3958">
        <h2 className="text-2xl font-bold text-navy mb-6" data-id="element-3959">Highlights</h2>
        <ul className="space-y-3" data-id="element-3960">
          {highlights.map((item, index) => <li key={index} className="flex items-start" data-id="element-3961">
              <span className="text-[#0077B6] mr-3 mt-1.5 text-xl leading-none" data-id="element-3962">
                •
              </span>
              <span className="text-gray-700 text-lg leading-relaxed" data-id="element-3963">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
      <div data-id="element-3964">
        <h2 className="text-2xl font-bold text-navy mb-6" data-id="element-3965">
          Mechanical Engineering
        </h2>
        <ul className="space-y-3" data-id="element-3966">
          {mechanicalEngineering.map((item, index) => <li key={index} className="flex items-start" data-id="element-3967">
              <span className="text-[#0077B6] mr-3 mt-1.5 text-xl leading-none" data-id="element-3968">
                •
              </span>
              <span className="text-gray-700 text-lg leading-relaxed" data-id="element-3969">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </div>;
}